<script>

    let { children } = $props();

</script>

<div class='legal'>
    {@render children?.()}
</div>

<style>

    .legal {
        font-style: italic;
        font-size: 0.9em;
        opacity: 0.6;

        margin-top: var(--margin-top, 0);
    }

    .legal :global(a) {
        color: var(--text-color);
        text-decoration: underline;
    }

</style>